import {
  SET_SAMPLE_DELETE_CONFIRM,
  SET_SAMPLE_DELETE_SUCCESS,
  SET_SAMPLE_DELETE_CANCEL,
  SET_CLEAR_ADD_SAMPLE,
  SET_CLEAR_SAMPLE_DETAIL,
  FETCH_SAMPLES,
  FETCH_SAMPLE_DETAIL,
  SET_SAMPLE_ID,
  SET_SAMPLE_FILES
} from "../actions/Samples";

const initialState = {
  sampleId: "",
  sampleList: {},
  sampleDetail: {},
  sampleDetailFiles: {},
  sampleDetailStatus: {},
  deleteSampleIdConfirm: false,
  deleteSampleIdSuccess: false
};

export default function samples(state = initialState, action) {
  switch (action.type) {
    case SET_CLEAR_SAMPLE_DETAIL:
      return {
        ...state,
        sampleDetail: {},
        sampleDetailStatus: {},
        sampleDetailFiles: {}
      };
    case FETCH_SAMPLES:
      return { ...state, sampleList: action.payload };
    case FETCH_SAMPLE_DETAIL:
      return { ...state, sampleDetail: action.payload };
    case SET_SAMPLE_DELETE_CONFIRM:
      return {
        ...state,
        deleteSampleIdConfirm: { showModal: true, sampleId: action.sampleId }
      };
    case SET_SAMPLE_DELETE_SUCCESS:
      return {
        ...state,
        deleteSampleIdConfirm: { showModal: false, sampleId: action.sampleId }
      };
    case SET_CLEAR_ADD_SAMPLE:
      return {
        ...state,
        files: {},
        sample: false
      };
    case SET_SAMPLE_DELETE_CANCEL:
      return {
        ...state,
        deleteSampleIdConfirm: false,
        deleteSampleIdSuccess: false
      };
    case SET_SAMPLE_ID:
      return {
        ...state,
        sampleId: action.sampleId
      };
    case SET_SAMPLE_FILES:
      return {
        ...state,
        sampleDetailFiles: [...state.sampleDetailFiles, action.payload]
      };
    default:
      return state;
  }
}
